/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * FilesControllerApi - axios parameter creator
 * @export
 */
export const FilesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {boolean} [thumbnail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentMainFile: async (id: number, thumbnail?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentMainFile', 'id', id)
            const localVarPath = `/api/files/doc/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (thumbnail !== undefined) {
                localVarQueryParameter['thumbnail'] = thumbnail;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} name 
         * @param {boolean} [thumbnail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentMainFileWithName: async (id: number, name: string, thumbnail?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentMainFileWithName', 'id', id)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getDocumentMainFileWithName', 'name', name)
            const localVarPath = `/api/files/doc/{id}/{name}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (thumbnail !== undefined) {
                localVarQueryParameter['thumbnail'] = thumbnail;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} appConnectorCode 
         * @param {string} objectId 
         * @param {string} filename 
         * @param {{ [key: string]: string; }} params 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalFile: async (appConnectorCode: string, objectId: string, filename: string, params: { [key: string]: string; }, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'appConnectorCode' is not null or undefined
            assertParamExists('getExternalFile', 'appConnectorCode', appConnectorCode)
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('getExternalFile', 'objectId', objectId)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('getExternalFile', 'filename', filename)
            // verify required parameter 'params' is not null or undefined
            assertParamExists('getExternalFile', 'params', params)
            const localVarPath = `/api/files/ext/{appConnectorCode}/{objectId}/{filename}`
                .replace(`{${"appConnectorCode"}}`, encodeURIComponent(String(appConnectorCode)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (params !== undefined) {
                localVarQueryParameter['params'] = params;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImagePaths: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/img`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesControllerApi - functional programming interface
 * @export
 */
export const FilesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {boolean} [thumbnail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentMainFile(id: number, thumbnail?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentMainFile(id, thumbnail, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} name 
         * @param {boolean} [thumbnail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentMainFileWithName(id: number, name: string, thumbnail?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentMainFileWithName(id, name, thumbnail, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} appConnectorCode 
         * @param {string} objectId 
         * @param {string} filename 
         * @param {{ [key: string]: string; }} params 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalFile(appConnectorCode: string, objectId: string, filename: string, params: { [key: string]: string; }, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalFile(appConnectorCode, objectId, filename, params, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImagePaths(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getImagePaths(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FilesControllerApi - factory interface
 * @export
 */
export const FilesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilesControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {boolean} [thumbnail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentMainFile(id: number, thumbnail?: boolean, options?: any): AxiosPromise<File> {
            return localVarFp.getDocumentMainFile(id, thumbnail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} name 
         * @param {boolean} [thumbnail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentMainFileWithName(id: number, name: string, thumbnail?: boolean, options?: any): AxiosPromise<File> {
            return localVarFp.getDocumentMainFileWithName(id, name, thumbnail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} appConnectorCode 
         * @param {string} objectId 
         * @param {string} filename 
         * @param {{ [key: string]: string; }} params 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalFile(appConnectorCode: string, objectId: string, filename: string, params: { [key: string]: string; }, context?: string, options?: any): AxiosPromise<File> {
            return localVarFp.getExternalFile(appConnectorCode, objectId, filename, params, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImagePaths(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getImagePaths(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FilesControllerApi - interface
 * @export
 * @interface FilesControllerApi
 */
export interface FilesControllerApiInterface {
    /**
     * 
     * @param {number} id 
     * @param {boolean} [thumbnail] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesControllerApiInterface
     */
    getDocumentMainFile(id: number, thumbnail?: boolean, options?: any): AxiosPromise<File>;

    /**
     * 
     * @param {number} id 
     * @param {string} name 
     * @param {boolean} [thumbnail] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesControllerApiInterface
     */
    getDocumentMainFileWithName(id: number, name: string, thumbnail?: boolean, options?: any): AxiosPromise<File>;

    /**
     * 
     * @param {string} appConnectorCode 
     * @param {string} objectId 
     * @param {string} filename 
     * @param {{ [key: string]: string; }} params 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesControllerApiInterface
     */
    getExternalFile(appConnectorCode: string, objectId: string, filename: string, params: { [key: string]: string; }, context?: string, options?: any): AxiosPromise<File>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesControllerApiInterface
     */
    getImagePaths(options?: any): AxiosPromise<Array<string>>;

}

/**
 * FilesControllerApi - object-oriented interface
 * @export
 * @class FilesControllerApi
 * @extends {BaseAPI}
 */
export class FilesControllerApi extends BaseAPI implements FilesControllerApiInterface {
    /**
     * 
     * @param {number} id 
     * @param {boolean} [thumbnail] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesControllerApi
     */
    public getDocumentMainFile(id: number, thumbnail?: boolean, options?: any) {
        return FilesControllerApiFp(this.configuration).getDocumentMainFile(id, thumbnail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} name 
     * @param {boolean} [thumbnail] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesControllerApi
     */
    public getDocumentMainFileWithName(id: number, name: string, thumbnail?: boolean, options?: any) {
        return FilesControllerApiFp(this.configuration).getDocumentMainFileWithName(id, name, thumbnail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} appConnectorCode 
     * @param {string} objectId 
     * @param {string} filename 
     * @param {{ [key: string]: string; }} params 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesControllerApi
     */
    public getExternalFile(appConnectorCode: string, objectId: string, filename: string, params: { [key: string]: string; }, context?: string, options?: any) {
        return FilesControllerApiFp(this.configuration).getExternalFile(appConnectorCode, objectId, filename, params, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesControllerApi
     */
    public getImagePaths(options?: any) {
        return FilesControllerApiFp(this.configuration).getImagePaths(options).then((request) => request(this.axios, this.basePath));
    }
}
